import React from "react";
import { Check, Loader2, AlertTriangle, Circle, Hand } from "lucide-react";

const STAGES = [
  { key: "scrape", label: "Ingest Listing" },
  { key: "analyse", label: "Analyse Photos" },
  { key: "transcript", label: "Write Script" },
  { key: "character", label: "Cast Agent" },
  { key: "generation", label: "Generate Clips" },
  { key: "render", label: "Render Video" },
];

const Dot = ({ status }) => {
  if (status === "done")
    return (
      <span className="w-6 h-6 rounded-full bg-emerald-500/15 border border-emerald-500 flex items-center justify-center">
        <Check className="w-3.5 h-3.5 text-emerald-400" />
      </span>
    );
  if (status === "running")
    return (
      <span className="relative w-6 h-6 rounded-full bg-amber-500/20 border border-amber-500 flex items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-amber-500/30 blur-md pulse-glow" />
        <Loader2 className="w-3.5 h-3.5 text-amber-400 animate-spin relative z-10" />
      </span>
    );
  if (status === "needs_input")
    return (
      <span className="w-6 h-6 rounded-full bg-amber-500/10 border border-amber-500 flex items-center justify-center">
        <Hand className="w-3.5 h-3.5 text-amber-400" />
      </span>
    );
  if (status === "error")
    return (
      <span className="w-6 h-6 rounded-full bg-red-500/15 border border-red-500 flex items-center justify-center">
        <AlertTriangle className="w-3.5 h-3.5 text-red-400" />
      </span>
    );
  return (
    <span className="w-6 h-6 rounded-full border border-zinc-700 flex items-center justify-center">
      <Circle className="w-2 h-2 text-zinc-600 fill-zinc-600" />
    </span>
  );
};

export default function PipelineTracker({ pipeline = {}, onStageClick }) {
  return (
    <div data-testid="pipeline-tracker" className="relative">
      {STAGES.map((s, i) => {
        const status = pipeline[s.key] || "pending";
        const active = status === "running" || status === "needs_input";
        return (
          <button
            key={s.key}
            onClick={() => onStageClick && onStageClick(s.key)}
            data-testid={`pipeline-stage-${s.key}`}
            className="flex items-start gap-3 w-full text-left group"
          >
            <div className="flex flex-col items-center">
              <Dot status={status} />
              {i < STAGES.length - 1 && (
                <span
                  className={`w-px h-8 my-1 ${
                    status === "done" ? "bg-emerald-500/40" : "bg-zinc-800"
                  }`}
                />
              )}
            </div>
            <div className="pt-0.5 pb-2">
              <p className="font-mono2 text-[10px] uppercase tracking-[0.15em] text-zinc-600">
                Step {i + 1}
              </p>
              <p
                className={`text-sm font-medium ${
                  active
                    ? "text-white"
                    : status === "done"
                    ? "text-zinc-400"
                    : status === "error"
                    ? "text-red-400"
                    : "text-zinc-600"
                }`}
              >
                {s.label}
              </p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
